/* theme.ts — dark mode toggle.
 *
 * The pre-paint initialisation stays inline in <head> in _layouts/default.html:
 * it has to run before first paint to avoid a flash of the light theme, which a
 * deferred external file cannot guarantee. This file only wires the button.
 */

(function () {
    'use strict';

    const button = document.getElementById('theme-toggle');
    if (!button) {
        return;
    }

    const root = document.documentElement;

    button.addEventListener('click', function () {
        const next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
        root.setAttribute('data-theme', next);
        try {
            window.localStorage.setItem('theme', next);
        } catch (_e) {
            /* Private browsing — the theme still applies for this page view. */
        }
    });

    /* Follow the OS if the reader has never made an explicit choice. */
    let explicit = null;
    try {
        explicit = window.localStorage.getItem('theme');
    } catch (_e) {
        explicit = null;
    }
    if (explicit === null) {
        const scheme = window.matchMedia('(prefers-color-scheme: dark)');
        scheme.addEventListener('change', function (e) {
            root.setAttribute('data-theme', e.matches ? 'dark' : 'light');
        });
    }
})();
